// extracted by mini-css-extract-plugin
export var animationContainer = "_hk-0";
export var asteriskIcon = "_hk-8";
export var conversationLeftSection = "_hk-4";
export var conversationListItem = "_hk-3";
export var conversationMiddleSection = "_hk-5";
export var conversationRightSection = "_hk-6";
export var detailsContent = "_hk-1";
export var listContainer = "_hk-7";
export var modalContent = "_hk-2";